/* tslint:disable */
/* eslint-disable */
import { Observable } from "rxjs";
import { filter, map } from "rxjs/operators";

import { HttpClient, HttpContext, HttpResponse } from "@angular/common/http";

import { ReverseRecordRead } from "../../models/reverse-record-read";
import { RequestBuilder } from "../../request-builder";
import { StrictHttpResponse } from "../../strict-http-response";

export interface ReadReverseRecord$Params {
  reverse_record_id: number;
  organisation_id: string;
  reverse_zone_id: number;
}

export function readReverseRecord(
  http: HttpClient,
  rootUrl: string,
  params: ReadReverseRecord$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<ReverseRecordRead>> {
  const rb = new RequestBuilder(rootUrl, readReverseRecord.PATH, "get");
  if (params) {
    rb.path("reverse_record_id", params.reverse_record_id, {});
    rb.path("organisation_id", params.organisation_id, {});
    rb.path("reverse_zone_id", params.reverse_zone_id, {});
  }

  // add this header so we are able to examine the failure response
  // otherwise it's intercepted by the http interceptor
  rb.header("x-ignore-interceptor", "1");

  const responseType = "json";
  return http.request(rb.build({ responseType, accept: "application/json", context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ReverseRecordRead>;
    }),
  );
}

readReverseRecord.PATH =
  "/surfdomeinen/organisations/{organisation_id}/reverse/{reverse_zone_id}/records/{reverse_record_id}";
